import handleSlider from '../sliders/handle-slider';

const handleRelatedProducts = (section = '.js-related-products') => {
  const $section = $(section);

  if ($section.length === 0) {
    return;
  }

  const productId = $section.data('product-id');
  const baseUrl = $section.data('base-url');
  const limit = $section.data('limit');
  const requestUrl = baseUrl + '?section_id=related-products&product_id=' + productId + '&limit=' + limit;

  $.ajax({
    url: requestUrl,
    type: 'GET',
    dataType: 'html',
  })
  .done(function(data) {
    $section.html($(data).find('.js-related-products').html());

    if ($section.find('.js-slider').length > 0 && ! $section.find('.js-slider').hasClass('slick-initialized')) {
      handleSlider($section.find('.js-slider'));
    }

    const api = new Yotpo.API(yotpo);
    api.refreshWidgets();
  });
}

handleRelatedProducts();

document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === 'related-products') {
   handleRelatedProducts();
  }
});
